import VIEW_MODE from '../constants/viewMode';
import DEVICE_TYPE from '../constants/deviceType';
var ViewModeWrapper = /** @class */ (function () {
    function ViewModeWrapper() {
        this.setViewMode = this.setViewMode.bind(this);
        this.isSiteMode = this.isSiteMode.bind(this);
        this.isEditMode = this.isEditMode.bind(this);
        this.isPreviewMode = this.isPreviewMode.bind(this);
        this.isSEOMode = this.isSEOMode.bind(this);
        this.setDeviceType = this.setDeviceType.bind(this);
        this.isDeviceTypeDesktop = this.isDeviceTypeDesktop.bind(this);
        this.isDeviceTypeMobile = this.isDeviceTypeMobile.bind(this);
        this.isDeviceTypeTablet = this.isDeviceTypeTablet.bind(this);
        this.isDeviceTypeTouch = this.isDeviceTypeTouch.bind(this);
        this._viewMode = VIEW_MODE.SITE;
        this._deviceType = DEVICE_TYPE.DESKTOP;
    }
    ViewModeWrapper.prototype.setViewMode = function (viewMode) {
        this._viewMode = viewMode;
    };
    ViewModeWrapper.prototype.setDeviceType = function (forceVal) {
        this._deviceType = forceVal;
    };
    ViewModeWrapper.prototype.isDeviceTypeMobile = function () {
        return this._deviceType === DEVICE_TYPE.MOBILE;
    };
    ViewModeWrapper.prototype.isDeviceTypeTablet = function () {
        return this._deviceType === DEVICE_TYPE.TABLET;
    };
    ViewModeWrapper.prototype.isDeviceTypeDesktop = function () {
        return this._deviceType === DEVICE_TYPE.DESKTOP;
    };
    ViewModeWrapper.prototype.isDeviceTypeTouch = function () {
        return this.isDeviceTypeMobile() || this.isDeviceTypeTablet();
    };
    ViewModeWrapper.prototype.isSiteMode = function () {
        return this._viewMode === VIEW_MODE.SITE;
    };
    ViewModeWrapper.prototype.isEditMode = function () {
        return this._viewMode === VIEW_MODE.EDIT;
    };
    ViewModeWrapper.prototype.isPreviewMode = function () {
        return this._viewMode === VIEW_MODE.PREVIEW;
    };
    ViewModeWrapper.prototype.isSEOMode = function () {
        return this._viewMode === VIEW_MODE.SEO;
    };
    return ViewModeWrapper;
}());
var viewModeWrapper = new ViewModeWrapper();
var isSiteMode = viewModeWrapper.isSiteMode;
var isEditMode = viewModeWrapper.isEditMode;
var isPreviewMode = viewModeWrapper.isPreviewMode;
var isSEOMode = viewModeWrapper.isSEOMode;
var isDeviceTypeMobile = viewModeWrapper.isDeviceTypeMobile;
var isDeviceTypeTablet = viewModeWrapper.isDeviceTypeTablet;
var isDeviceTypeDesktop = viewModeWrapper.isDeviceTypeDesktop;
var isDeviceTypeTouch = viewModeWrapper.isDeviceTypeTouch;
export { viewModeWrapper };
export { isSiteMode };
export { isEditMode };
export { isPreviewMode };
export { isSEOMode };
export { isDeviceTypeMobile };
export { isDeviceTypeTablet };
export { isDeviceTypeDesktop };
export { isDeviceTypeTouch };
//# sourceMappingURL=viewModeWrapper.js.map